import { Outlet } from "react-router-dom"
import styled from "styled-components"

export const EditorLayout = () => {
    return (
        <StyledEditorLayout>
            <Outlet/>
        </StyledEditorLayout>
    )
}

const StyledEditorLayout = styled.div`
    width: 100%;
    height: 100%;
`